"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useIsAuthenticated } from "@refinedev/core";
import { RobotLoader } from "@/components/ui/robot-loader";

export default function HomePage() {
    const router = useRouter();
    const { data: isAuthenticated, isLoading } = useIsAuthenticated();

    useEffect(() => {
        if (!isLoading) {
            if (isAuthenticated?.authenticated) {
                const postShadowRedirect = sessionStorage.getItem("post_shadow_redirect");
                if (postShadowRedirect) {
                    sessionStorage.removeItem("post_shadow_redirect");
                    router.replace(postShadowRedirect);
                } else {
                    router.replace("/dashboard");
                }
            } else {
                // Redirect to login when not authenticated
                router.replace("/login");
            }
        }
    }, [isAuthenticated, isLoading, router]);

    // Show loading state while checking authentication
    return (
        <div className="flex min-h-screen items-center justify-center">
            <RobotLoader variant="searching" label="Checking your session" />
        </div>
    );
}
